<p>Are you sure to delete group <strong>{{ data?.name }}</strong> ?</p>
<div class="block block-warning">
    <div class="red-1">
        <i class="fas fa-exclamation-circle"></i>
        <span class="ml-2">Warning</span>
    </div>
    Users under the removed group will be moved to 'Ungrouped users'.
</div>